// Arabic strings for the people & records stream — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed
// until decision H-10 names a reviewer.
import type { enPeople } from './en-people.ts';
import type { Message } from './types.ts';

export const arPeople: { readonly [K in keyof typeof enPeople]: Message } = {
  // ------------------------------------------------------------ navigation, roles, reception
  'nav.screening': 'التدقيق الأمني',
  'specialist.screening-list-manager': 'مدير قوائم التدقيق',
  'specialist.restricted-profile-reader': 'قارئ بيانات الملفات المقيّدة',
  'rcp.blocker.security_review': 'يلزم إجراء مراجعة أمنية قبل الوصول. اطلب مشرف الأمن ولا تناقش السبب مع الزائر.',
  'rcp.blocker.screening_unavailable': 'تعذّر إكمال الفحص الأمني أو أصبح قديمًا. أعد تشغيل الفحص.',
  'rcp.warning.security_review': 'توجد مراجعة أمنية مفتوحة لهذا الزائر. أبلغ مشرف الأمن.',
  'rcp.warning.screening_unavailable': 'تعذّر إكمال الفحص الأمني أو أصبح قديمًا.',
  'ppl.rcp.runCheck': 'أعد تشغيل الفحص الأمني',
  'ppl.rcp.checkDone': 'سُجّل الفحص الأمني.',

  // ------------------------------------------------------------ API and validation messages
  'ppl.api.revealExpired': 'انتهت صلاحية هذا الكشف. اكشف مرة أخرى مع ذكر الغرض.',
  'ppl.api.hostSyncDisabled': 'مزامنة المضيفين غير مفعّلة لاتصال الدليل هذا.',
  'ppl.api.hostAlreadyLinked': 'هذا المضيف مرتبط بدليل بالفعل.',
  'ppl.api.providerListReadOnly': 'إدخالات قائمة المزوّد تأتي من المزوّد ولا يمكن تعديلها هنا.',
  'ppl.api.entryRemoved': 'أُزيل هذا الإدخال بالفعل.',
  'ppl.api.participantRemoved': 'أُزيل هذا الشخص من الزيارة.',
  'ppl.api.caseDecided': 'صدر قرار في هذه الحالة بالفعل.',
  'ppl.api.ownVisitCase': 'أنت مضيف هذه الزيارة أو منشئها، لذا يجب أن يقرر مراجع آخر في هذه الحالة.',
  'ppl.api.importOpen': 'يجري استيراد هذا الملف بالفعل. أكمل ذلك الاستيراد أو تجاهله أولًا.',
  'ppl.api.importNotEditable': 'لم يعد بالإمكان تغيير هذا الاستيراد.',
  'ppl.api.importRowNotDecidable': 'لا يُتخذ قرار إلا للصفوف الصالحة أو التكرارات المحتملة.',
  'ppl.api.importPolicyFixed': 'يُطبَّق هذا الاستيراد بالفعل وفق سياسة أخرى.',
  'ppl.api.importHasProblems': 'بعض الصفوف غير صالحة أو ما زالت تحتاج إلى قرار بشأن التكرار. أصلحها أو اختر «تطبيق الصفوف الصالحة فقط».',
  'ppl.api.importChanged': 'تعذّر تطبيق صف لأن السجلات تغيّرت منذ التشغيل التجريبي. لم يُطبَّق شيء. أعد تشغيل الاستيراد.',
  'ppl.v.reason': 'اذكر سببًا (3 أحرف على الأقل).',
  'ppl.v.fieldKey': 'استخدم أحرفًا لاتينية صغيرة وأرقامًا وشرطات سفلية، على أن يبدأ بحرف.',
  'ppl.v.option': 'اختر أحد الخيارات المدرجة.',
  'ppl.v.country': 'استخدم رمز دولة من حرفين (مثل AE).',
  'ppl.v.formula': 'يجب ألا تبدأ القيم بالرموز = أو + أو - أو @ (حماية من صيغ جداول البيانات).',
  'ppl.v.fieldUnknown': 'هذا الحقل غير مهيأ لهذا السجل أو هذه الفئة.',
  'ppl.v.purpose': 'اختر أحد الأغراض المهيأة.',
  'ppl.v.externalIdTaken': 'يستخدم مضيف آخر معرّف الدليل هذا بالفعل.',
  'ppl.v.hostDirectoryOwned': 'تأتي هذه القيمة من دليل الموظفين وتُغيَّر هناك.',
  'ppl.v.simulatorProduction': 'لا يمكن استخدام محاكي التدقيق في بيئة الإنتاج.',
  'ppl.v.validUntil': 'لا يمكن أن يسبق تاريخ الانتهاء تاريخ البدء.',
  'ppl.v.reviewerUnknown': 'اختر مستخدمًا يمكنه مراجعة حالات التدقيق في هذا الموقع.',
  'ppl.v.locale': 'استخدم en أو ar.',
  'ppl.v.employeeNumber': 'استخدم من 1 إلى 50 حرفًا أو رقمًا أو نقطة أو شرطة سفلية أو شرطة.',
  'ppl.v.siteCode': 'لا يوجد موقع بهذا الرمز.',
  'ppl.v.orgKind': 'استخدم visitor أو contractor أو vendor أو delivery أو government أو other.',
  'ppl.v.changedSinceValidation': 'تغيّرت السجلات منذ التشغيل التجريبي؛ لم يُطبَّق هذا الصف.',
  'ppl.v.headerUnknown': 'هذا العمود غير موجود في الملف.',
  'ppl.v.headerBlocked': 'لا تُستورد أعمدة بيانات الاعتماد والأسرار أبدًا.',
  'ppl.v.fieldMappedTwice': 'لا يُربط كل حقل إلا بعمود واحد.',
  'ppl.v.requiredColumn': 'اربط عمودًا بهذا الحقل المطلوب.',
  'ppl.v.matchUnknown': 'اختر أحد التطابقات المحتملة المدرجة.',
  'ppl.v.noMerge': 'لا تُدمج الأشخاص والجهات أبدًا؛ استخدم السجل الموجود أو أنشئ سجلًا منفصلًا.',
  'ppl.v.dict.duplicate': 'هذا المفتاح مستخدم مرتين.',
  'ppl.v.dict.reserved': 'هذا المفتاح حقل مدمج.',
  'ppl.v.dict.forbidden': 'لا يمكن تهيئة حقول بيانات الاعتماد أو الأسرار.',
  'ppl.v.dict.options': 'أضف خيارًا واحدًا على الأقل.',
  'ppl.v.dict.range': 'الحد الأدنى أكبر من الحد الأقصى.',
  'ppl.v.dict.purpose': 'رمز الغرض هذا مستخدم مرتين.',
  'ppl.v.dict.category': 'فئة زوار غير معروفة.',
  'ppl.import.p.empty': 'لا يحتوي الملف على صفوف.',
  'ppl.import.p.tooLarge': 'الملف كبير جدًا.',
  'ppl.import.p.notUtf8': 'يجب أن تكون ملفات CSV بترميز UTF-8.',
  'ppl.import.p.binary': 'الملف ليس ملف CSV نصيًا.',
  'ppl.import.p.quote': 'توجد قيمة بين علامتي تنصيص لم تُغلق.',
  'ppl.import.p.tooManyRows': 'يحتوي الملف على صفوف أكثر مما يتسع له استيراد واحد.',
  'ppl.import.p.tooManyColumns': 'يحتوي الملف على أعمدة كثيرة جدًا.',
  'ppl.import.p.notXlsx': 'الملف ليس مصنف XLSX قابلًا للقراءة.',
  'ppl.import.p.macro': 'لا تُقبل المصنفات التي تحتوي على وحدات ماكرو.',
  'ppl.import.p.blankHeader': 'يحتاج كل عمود إلى عنوان في الصف الأول.',
  'ppl.import.p.duplicateHeader': 'يوجد عمودان بالعنوان نفسه.',
  'ppl.import.p.encoding': 'تعذّرت قراءة الملف.',
  'ppl.import.f.givenName': 'الاسم الأول',
  'ppl.import.f.familyName': 'اسم العائلة',
  'ppl.import.f.email': 'البريد الإلكتروني',
  'ppl.import.f.phone': 'الهاتف المحمول',
  'ppl.import.f.organisation': 'الجهة',
  'ppl.import.f.preferredLocale': 'اللغة (en/ar)',
  'ppl.import.f.displayName': 'الاسم',
  'ppl.import.f.employeeNumber': 'الرقم الوظيفي',
  'ppl.import.f.department': 'القسم',
  'ppl.import.f.jobTitle': 'المسمى الوظيفي',
  'ppl.import.f.officeSiteCode': 'رمز موقع المكتب',
  'ppl.import.f.name': 'اسم الجهة',
  'ppl.import.f.kind': 'النوع',

  // ------------------------------------------------------------ tabs and shared labels
  'ppl.tab.hostSync': 'مزامنة المضيفين',
  'ppl.tab.import': 'الاستيراد',
  'ppl.tab.fields': 'قاموس الحقول',
  'ppl.class.standard': 'عادي',
  'ppl.class.contact': 'تواصل',
  'ppl.class.identity': 'هوية',
  'ppl.class.restricted': 'مقيّد',
  'ppl.class.standard.hint': 'يظهر لكل من يستطيع رؤية الملف.',
  'ppl.class.contact.hint': 'يظهر كاملًا للمضيفين والاستقبال، ومخفيًا جزئيًا للمعتمدين.',
  'ppl.class.identity.hint': 'مخفي دائمًا؛ يكشفه محققو الهوية لغرض مذكور.',
  'ppl.class.restricted.hint': 'مخفي دائمًا؛ يكشفه قرّاء الملفات المقيّدة لغرض مذكور.',
  'ppl.type.text': 'نص',
  'ppl.type.number': 'رقم',
  'ppl.type.date': 'تاريخ',
  'ppl.type.boolean': 'نعم / لا',
  'ppl.type.select': 'اختيار',
  'ppl.type.email': 'بريد إلكتروني',
  'ppl.type.phone': 'هاتف',
  'ppl.type.country': 'رمز الدولة',
  'ppl.collect.none': 'لا يُجمع',
  'ppl.collect.all': 'كل الفئات',
  'ppl.collect.categories': 'الفئات المدرجة',

  // ------------------------------------------------------------ profile fields and reveals (PB-03-07)
  'ppl.fields.title': 'تفاصيل الملف',
  'ppl.fields.sub': 'الحقول المهيأة. تبقى قيم الهوية والقيم المقيّدة مخفية ما لم يسمح دورك بكشفها لغرض مذكور.',
  'ppl.fields.edit': 'تعديل التفاصيل',
  'ppl.fields.editSub': 'تُحفظ الحقول المعدّلة فقط. تُكتب قيم الهوية والقيم المقيّدة كاملة وتظهر مخفية بعد ذلك.',
  'ppl.fields.history': 'سجل الاطلاع',
  'ppl.fields.none': 'لا توجد تفاصيل مهيأة لهذا الشخص.',
  'ppl.fields.noneHost': 'لا توجد حقول مضيفين مهيأة في قاموس الحقول.',
  'ppl.fields.hostTitle': 'تفاصيل المضيف · {name}',
  'ppl.fields.masked': 'قيمة مخفية',
  'ppl.fields.reveal': 'كشف',
  'ppl.fields.hide': 'إخفاء الآن',
  'ppl.fields.revealedFor': 'تظهر القيم المكشوفة لمدة {seconds} ثانية أخرى.',
  'ppl.fields.maskNote': 'يُسجَّل الكشف باسمك والغرض والوقت. لا تُحفظ القيم على هذا الجهاز أبدًا.',
  'ppl.fields.writeOnly': 'القيمة الحالية {masked}. اتركه فارغًا للإبقاء عليها.',
  'ppl.reveal.title': 'كشف التفاصيل المخفية',
  'ppl.reveal.sub': 'تظهر القيم لمدة {seconds} ثانية ويُسجَّل الكشف.',
  'ppl.reveal.purpose': 'الغرض',
  'ppl.reveal.note': 'ملاحظة (اختيارية)',
  'ppl.reveal.noteHint': 'مثل رقم مرجع المكتب أو الحالة.',
  'ppl.reveal.audited': 'يُسجَّل اسمك والغرض والحقول والوقت في سجل الاطلاع.',
  'ppl.history.none': 'لا توجد عمليات كشف مسجّلة.',
  'ppl.history.when': 'الوقت',
  'ppl.history.who': 'الشخص',
  'ppl.history.fields': 'الحقول',

  // ------------------------------------------------------------ host directory additions (PB-03-02, OR-08)
  'ppl.hosts.fields': 'التفاصيل',
  'ppl.hosts.deactivateReassign': 'إلغاء التفعيل وتحويل هذه الزيارات لإعادة التعيين',
  'ppl.hosts.reassignReason': 'أُلغي تفعيل المضيف؛ حُوّلت الزيارات المقبلة لإعادة التعيين',

  // ------------------------------------------------------------ visitor policy (PB-03-06)
  'ppl.policy.screening': 'التدقيق في قوائم المراقبة',
  'ppl.policy.screeningHint': 'يُعلَّق التطابق المحتمل لمراجعة مشرف الأمن؛ ولا يكون رفضًا تلقائيًا أبدًا، ولا يظهر السبب للاستقبال أو المضيفين أو الزوار.',
  'ppl.policy.mode': 'التطابق المحتمل',
  'ppl.policy.mode.off': 'دون تدقيق',
  'ppl.policy.mode.warn': 'تنبيه الاستقبال',
  'ppl.policy.mode.block': 'تعليق الوصول حتى المراجعة',
  'ppl.policy.unavailable': 'الفحص غير متاح أو قديم',

  // ------------------------------------------------------------ screening workspace (PB-03-06)
  'ppl.scr.eyebrow': 'الأمن',
  'ppl.scr.title': 'التدقيق الأمني',
  'ppl.scr.intro': 'التطابقات المحتملة مع قوائم المراقبة وقوائم المنع بانتظار المراجعة، والقوائم التي جاءت منها.',
  'ppl.scr.restricted': 'معلومات مقيّدة',
  'ppl.scr.restrictedNote': 'لا تظهر القوائم والتطابقات والأسباب إلا لموظفي الأمن المسمَّين. لا تشاركها أبدًا مع الزوار أو المضيفين أو الاستقبال؛ فالتطابق سبب للمراجعة وليس للرفض.',
  'ppl.scr.tab.cases': 'الحالات',
  'ppl.scr.tab.lists': 'القوائم',
  'ppl.scr.tab.settings': 'الإعدادات',
  'ppl.scr.cases': 'الحالات · {site}',
  'ppl.scr.casesSub': 'حالة واحدة لكل زائر وزيارة. قرّر في كل منها مع ذكر السبب.',
  'ppl.scr.status': 'الحالة',
  'ppl.scr.otherSite': 'لا تراجع حالات التدقيق في موقع العمل الحالي. اختر موقعًا آخر.',
  'ppl.scr.noCases': 'لا توجد حالات هنا.',
  'ppl.scr.col.person': 'الشخص',
  'ppl.scr.col.visit': 'الزيارة',
  'ppl.scr.col.score': 'درجة التطابق',
  'ppl.scr.col.status': 'الحالة',
  'ppl.scr.col.reviewer': 'المراجع',
  'ppl.scr.opened': 'فُتحت {when}',
  'ppl.scr.candidates': { zero: 'لا توجد تطابقات محتملة', one: 'تطابق محتمل واحد', two: 'تطابقان محتملان', few: '{count} تطابقات محتملة', many: '{count} تطابقًا محتملًا', other: '{count} تطابق محتمل' },
  'ppl.scr.unassigned': 'غير معيّنة',
  'ppl.scr.review': 'مراجعة',
  'ppl.scr.listsSub': 'القوائم التي تديرها. تحتاج القوائم على مستوى المؤسسة إلى صلاحية على مستوى المؤسسة.',
  'ppl.case.status.open': 'بانتظار المراجعة',
  'ppl.case.status.cleared': 'أُخلي سبيلها',
  'ppl.case.status.confirmed': 'تطابق مؤكد',
  'ppl.case.status.all': 'الكل',
  'ppl.case.title': 'حالة تدقيق',
  'ppl.case.sub': 'قارن الزائر بكل مرشح قبل اتخاذ القرار.',
  'ppl.case.candidates': 'المرشحون',
  'ppl.case.candidatesNote': 'تأتي الدرجات من مطابقة تقريبية للأسماء بين التهجئة العربية واللاتينية؛ وهي ليست دليلًا على الهوية.',
  'ppl.case.list': 'القائمة',
  'ppl.case.matched': 'الاسم المطابق',
  'ppl.case.reason': 'سبب الإدراج',
  'ppl.case.previous': 'حالات سابقة لهذا الشخص',
  'ppl.case.disposition': 'القرار',
  'ppl.case.reasonLabel': 'سبب القرار',
  'ppl.case.reasonHint': 'مطلوب. يُحفظ مع الحالة ولا يظهر أبدًا خارج المراجعة الأمنية.',
  'ppl.case.note': 'ملاحظة مقيّدة (اختيارية)',
  'ppl.case.noteHint': 'لا تظهر إلا لمراجعي التدقيق.',
  'ppl.case.decide': 'تسجيل القرار',
  'ppl.case.events': 'سجل الحالة',
  'ppl.disposition.false_positive': 'ليس الشخص المدرج (تطابق خاطئ)',
  'ppl.disposition.not_relevant': 'الشخص المدرج، ويمكنه المتابعة',
  'ppl.disposition.confirmed_match': 'تطابق مؤكد — يبقى مرفوضًا',
  'ppl.disposition.false_positive.hint': 'يرفع التعليق. لن يُشار إلى الشخص نفسه مجددًا لهذه الإدخالات ما دامت دون تغيير.',
  'ppl.disposition.not_relevant.hint': 'يرفع التعليق لهذه الزيارة فقط، مثلًا عند الاتفاق على مرافق.',
  'ppl.disposition.confirmed_match.hint': 'يبقى الوصول ممنوعًا لهذه الزيارة. لا يرى الاستقبال إلا أن مراجعة أمنية مطلوبة.',
  'ppl.event.opened': 'فُتحت',
  'ppl.event.candidates_added': 'أُضيف مرشحون جدد',
  'ppl.event.assigned': 'عُيّنت',
  'ppl.event.decided': 'صدر القرار',
  'ppl.event.note': 'ملاحظة',
  'ppl.match.name_exact': 'الاسم نفسه',
  'ppl.match.name_fuzzy': 'تهجئة مشابهة',
  'ppl.match.name_transliterated': 'نقل حرفي عربي/لاتيني',
  'ppl.match.alias': 'اسم بديل',
  'ppl.match.dob_match': 'تاريخ الميلاد نفسه',
  'ppl.match.dob_mismatch': 'تاريخ ميلاد مختلف',
  'ppl.match.identifier': 'وسيلة التواصل أو المستند نفسه',
  'ppl.reason.safety_incident': 'حادث سلامة',
  'ppl.reason.trespass': 'تعدٍّ',
  'ppl.reason.legal_order': 'أمر قانوني',
  'ppl.reason.policy_violation': 'مخالفة سياسة',
  'ppl.reason.provider_listed': 'مدرج لدى المزوّد',
  'ppl.reason.other': 'أخرى',
  'ppl.list.add': 'إضافة قائمة',
  'ppl.list.addSub': 'سجّل مصدر القائمة والجهة المخوّلة بها.',
  'ppl.list.none': 'لا توجد قوائم بعد.',
  'ppl.list.name': 'الاسم',
  'ppl.list.scope': 'تنطبق في',
  'ppl.list.kind': 'النوع',
  'ppl.list.kind.deny': 'قائمة منع',
  'ppl.list.kind.watch': 'قائمة مراقبة',
  'ppl.list.source': 'المصدر',
  'ppl.list.source.manual': 'محفوظة في Passage',
  'ppl.list.source.provider': 'مزوّد تدقيق',
  'ppl.list.providerHint': 'لم يُتعاقد مع مزوّد بعد؛ لا يتوفر إلا محاكي التطوير (يُرفض في الإنتاج).',
  'ppl.list.provenance': 'المصدر والجهة',
  'ppl.list.provenanceHint': 'من يحتفظ بالقائمة وبموجب أي صلاحية.',
  'ppl.list.entries': 'الإدخالات',
  'ppl.list.providerEntries': 'من المزوّد',
  'ppl.list.changed': 'تغيّرت {when}',
  'ppl.list.manageEntries': 'الإدخالات',
  'ppl.list.activate': 'تفعيل',
  'ppl.list.deactivate': 'إلغاء التفعيل',
  'ppl.list.activateSub': 'يُعاد تدقيق الزيارات المقبلة مقابل هذه القائمة.',
  'ppl.list.deactivateSub': 'تتوقف القائمة عن الاستخدام في الفحوص الجديدة. تبقى الحالات المفتوحة مفتوحة.',
  'ppl.entry.sub': 'إدخالات مقيّدة. يُسجَّل فتح هذه القائمة.',
  'ppl.entry.none': 'لا توجد إدخالات.',
  'ppl.entry.add': 'إضافة إدخال',
  'ppl.entry.addSub': 'يُعاد تدقيق الزيارات المقبلة بعد الحفظ.',
  'ppl.entry.name': 'الاسم الكامل',
  'ppl.entry.nameHint': 'بالحروف العربية أو اللاتينية؛ تُطابق كلتاهما.',
  'ppl.entry.aliases': 'تهجئات أخرى',
  'ppl.entry.aliasesHint': 'واحدة في كل سطر.',
  'ppl.entry.dob': 'تاريخ الميلاد',
  'ppl.entry.idKind': 'نوع المعرّف',
  'ppl.entry.idValue': 'المعرّف',
  'ppl.entry.id.email': 'البريد الإلكتروني',
  'ppl.entry.id.phone': 'الهاتف',
  'ppl.entry.id.document': 'رقم المستند',
  'ppl.entry.validFrom': 'صالح من',
  'ppl.entry.validUntil': 'صالح حتى',
  'ppl.entry.sourceRef': 'مرجع المصدر',
  'ppl.entry.noteHint': 'لا تظهر إلا لمراجعي التدقيق ومديري القوائم.',
  'ppl.entry.remove': 'إزالة',
  'ppl.entry.status.active': 'نشط',
  'ppl.entry.status.removed': 'أُزيل',
  'ppl.set.sub': 'سلوك التدقيق على مستوى المؤسسة. القيم افتراضات تطوير حتى تُراجع.',
  'ppl.set.threshold': 'عتبة التطابق (0.6–1)',
  'ppl.set.suppressionDays': 'تذكّر التطابقات الخاطئة التي أُخلي سبيلها (أيام)',
  'ppl.set.providerTimeoutMs': 'مهلة المزوّد (ملي ثانية)',
  'ppl.set.rescreenHorizonDays': 'إعادة تدقيق الزيارات خلال (أيام)',
  'ppl.set.rescreenMax': 'إعادة التدقيق بحد أقصى (زوار لكل تغيير)',
  'ppl.set.note': 'تُعامل مهلة المزوّد على أنها عدم توفر، وليست نتيجة سليمة أبدًا.',

  // ------------------------------------------------------------ host sync (PB-03-09)
  'ppl.hs.intro': 'حافظ على توافق دليل المضيفين مع دليل الموظفين.',
  'ppl.hs.title': 'مزامنة دليل المضيفين',
  'ppl.hs.note': 'يُطابق المضيفون بالمعرّف الدائم في الدليل، وليس بالبريد الإلكتروني أبدًا. لا يُحذف المضيفون أبدًا: عندما يغادر شخص الدليل يصبح ملفه كمضيف غير نشط وتنتظر زياراته المقبلة إعادة التعيين.',
  'ppl.hs.none': 'لا يوجد اتصال بدليل بعد.',
  'ppl.hs.toIdentity': 'اربط دليلًا من مزوّدي الهوية',
  'ppl.hs.enabled': 'مزامنة المضيفين مفعّلة',
  'ppl.hs.disabled': 'مزامنة المضيفين متوقفة',
  'ppl.hs.configure': 'التهيئة',
  'ppl.hs.run': 'مزامنة المضيفين الآن',
  'ppl.hs.confirm': 'تطبيق عمليات إلغاء التفعيل المعلّقة',
  'ppl.hs.stale': 'تعذّرت قراءة الدليل في آخر تشغيل. قد تكون تفاصيل المضيفين قديمة.',
  'ppl.hs.owned': 'المضيفون من هذا الدليل',
  'ppl.hs.inactive': 'غير نشطين',
  'ppl.hs.mapping': 'ربط السمات',
  'ppl.hs.lastRun': 'آخر تشغيل',
  'ppl.hs.result': 'أُنشئ {created}، حُدّث {updated}، أُلغي تفعيل {deactivated}، أُعيد تفعيل {reactivated}، دون تغيير {unchanged}، تعارضات {conflicts}، زيارات لإعادة التعيين {reassignments}.',
  'ppl.hs.enable': 'مزامنة المضيفين بعد كل تشغيل للدليل',
  'ppl.hs.linkAccounts': 'ربط كل مضيف بحساب الدخول من إدخال الدليل نفسه',
  'ppl.hs.mappingHint': 'أسماء سمات الدليل. اتركها فارغة لإبقاء الحقل مُدارًا في Passage.',
  'ppl.hs.f.department': 'القسم',
  'ppl.hs.f.jobTitle': 'المسمى الوظيفي',
  'ppl.hs.f.employeeNumber': 'الرقم الوظيفي',
  'ppl.hs.f.officeSiteCode': 'رمز موقع المكتب',
  'ppl.hs.outcome.succeeded': 'اكتمل',
  'ppl.hs.outcome.held': 'معلّق بانتظار التأكيد',
  'ppl.hs.outcome.failed': 'الدليل غير متاح',
  'ppl.hs.conflict.host_exists': 'يوجد مضيف بهذا البريد بالفعل؛ اربطه صراحةً إن كان الشخص نفسه',
  'ppl.hs.conflict.employee_number_in_use': 'الرقم الوظيفي مستخدم لمضيف آخر',
  'ppl.hs.conflict.duplicate_external_id': 'معرّف الدليل مكرر أو يتبع مصدرًا آخر',
  'ppl.hs.conflict.invalid_entry': 'إدخال دليل غير صالح',
  'ppl.hs.conflict.office_site_unknown': 'رمز موقع مكتب غير معروف',
  'ppl.hs.conflict.deactivation_threshold': 'عدد غير معتاد من عمليات إلغاء التفعيل — معلّقة حتى التأكيد',
  'ppl.hs.conflict.administrator_hold': 'ألغى مسؤول تفعيله؛ لا يُعاد تفعيله تلقائيًا',
  'ppl.hs.conflict.account_linked_elsewhere': 'حساب الدخول مرتبط بمضيف آخر',
  'ppl.ra.title': 'زيارات بانتظار إعادة التعيين',
  'ppl.ra.sub': 'زيارات مقبلة لم يعد مضيفها الرئيسي نشطًا.',
  'ppl.ra.none': 'لا توجد زيارات بانتظار إعادة التعيين.',
  'ppl.ra.host': 'المضيف غير النشط',
  'ppl.ra.reason': 'السبب',
  'ppl.ra.reason.host_inactive_directory': 'غادر دليل الموظفين',
  'ppl.ra.reason.host_inactive_manual': 'ألغى مسؤول تفعيله',
  'ppl.ra.how': 'يغيّر مضيف مفوَّض في الموقع المضيفَ الرئيسي للزيارة، فيُطلب الاعتماد مجددًا وفق السياسة السارية.',

  // ------------------------------------------------------------ import (PB-03-10)
  'ppl.imp.intro': 'استورد المضيفين وملفات الزوار والجهات من ملفات CSV أو XLSX.',
  'ppl.imp.title': 'استيراد السجلات',
  'ppl.imp.sub': 'لا يتغير شيء حتى تطبّق. لا تُدمج التكرارات تلقائيًا أبدًا، ولا تُستورد أبدًا أعمدة كلمات المرور والرموز والأسرار الأخرى.',
  'ppl.imp.kind': 'السجلات',
  'ppl.imp.kind.people': 'ملفات الزوار',
  'ppl.imp.kind.hosts': 'المضيفون',
  'ppl.imp.kind.organisations': 'الجهات',
  'ppl.imp.file': 'الملف',
  'ppl.imp.fileHint': 'CSV (بترميز UTF-8) أو XLSX، والصف الأول عناوين. لا تُحسب الصيغ وتُرفض المصنفات التي تحتوي على وحدات ماكرو.',
  'ppl.imp.mapping': 'ربط الأعمدة',
  'ppl.imp.mappingHint': 'عُثر على {rows} صف. اختر الحقل لكل عمود؛ لا تُخزَّن الأعمدة غير المربوطة.',
  'ppl.imp.blocked': 'لا يُستورد أبدًا',
  'ppl.imp.column': 'العمود',
  'ppl.imp.field': 'الحقل',
  'ppl.imp.fieldFor': 'حقل العمود {column}',
  'ppl.imp.ignore': 'لا تستورد',
  'ppl.imp.neverImported': 'لا يُستورد أبدًا',
  'ppl.imp.dryRun': 'فحص الملف (تشغيل تجريبي)',
  'ppl.imp.history': 'عمليات الاستيراد',
  'ppl.imp.none': 'لا توجد عمليات استيراد بعد.',
  'ppl.imp.counts': 'الصفوف',
  'ppl.imp.countsLine': '{rows} صف · {valid} صالح · {invalid} غير صالح · {duplicate} تكرار محتمل · {applied} مطبَّق · {skipped} متجاوز',
  'ppl.imp.open': 'فتح',
  'ppl.imp.status.uploaded': 'مرفوع',
  'ppl.imp.status.validated': 'مفحوص — لم يُطبَّق',
  'ppl.imp.status.applying': 'قيد التطبيق',
  'ppl.imp.status.applied': 'مطبَّق',
  'ppl.imp.status.discarded': 'متجاهَل',
  'ppl.imp.report': 'تقرير التشغيل التجريبي · {file}',
  'ppl.imp.show': 'عرض',
  'ppl.imp.row.all': 'كل الصفوف',
  'ppl.imp.row.pending': 'قيد الانتظار',
  'ppl.imp.row.valid': 'صالح',
  'ppl.imp.row.invalid': 'غير صالح',
  'ppl.imp.row.duplicate': 'تكرار محتمل',
  'ppl.imp.row.applied': 'مطبَّق',
  'ppl.imp.row.skipped': 'متجاوز',
  'ppl.imp.ignored': 'أعمدة لم تُستورد',
  'ppl.imp.rows': 'الصفوف',
  'ppl.imp.rowNo': 'الصف',
  'ppl.imp.values': 'القيم',
  'ppl.imp.problems': 'المشكلات والتطابقات المحتملة',
  'ppl.imp.possible': 'تطابقات محتملة',
  'ppl.imp.useExisting': 'استخدام هذا السجل',
  'ppl.imp.updateExisting': 'تحديث هذا المضيف',
  'ppl.imp.createSeparate': 'إنشاء سجل منفصل',
  'ppl.imp.skip': 'تجاوز الصف',
  'ppl.imp.decided': 'القرار: {decision}',
  'ppl.imp.decision.create': 'إنشاء منفصل',
  'ppl.imp.decision.use_existing': 'استخدام السجل الموجود',
  'ppl.imp.decision.update_existing': 'تحديث المضيف الموجود',
  'ppl.imp.decision.skip': 'تجاوز',
  'ppl.imp.policy': 'طريقة التطبيق',
  'ppl.imp.policy.all_or_nothing': 'كل الصفوف أو لا شيء',
  'ppl.imp.policy.valid_rows_only': 'الصفوف الصالحة فقط',
  'ppl.imp.policy.all_or_nothing.hint': 'يطبّق كل الصفوف في خطوة واحدة. يُرفض ما دام هناك صف غير صالح أو تكرار دون قرار.',
  'ppl.imp.policy.valid_rows_only.hint': 'يطبّق الصفوف الصالحة على دفعات؛ وتُتجاوز الصفوف غير الصالحة وغير المحسومة وتُدرج.',
  'ppl.imp.apply': 'تطبيق',
  'ppl.imp.discard': 'تجاهل',
  'ppl.imp.progress': 'طُبّق {applied}، ويتبقى {remaining}…',

  // ------------------------------------------------------------ field dictionary (OR-07, OR-08)
  'ppl.dict.intro': 'حدّد التفاصيل الإضافية التي تُحفظ للزوار والمضيفين وكيفية حمايتها ومتى تُطلب.',
  'ppl.dict.title': 'قاموس الحقول',
  'ppl.dict.published': 'الإصدار {number} هو الساري.',
  'ppl.dict.draft': 'مسودة الإصدار {number} بانتظار النشر.',
  'ppl.dict.person': 'حقول ملفات الزوار',
  'ppl.dict.personSub': 'لا يُطلب الحقل إلا في الفئات التي تختارها؛ وتعريفه لا يعني جمعه.',
  'ppl.dict.host': 'حقول المضيفين',
  'ppl.dict.hostSub': 'تفاصيل إضافية في سجلات المضيفين.',
  'ppl.dict.addField': 'إضافة حقل',
  'ppl.dict.noFields': 'لا توجد حقول.',
  'ppl.dict.removeField': 'إزالة الحقل {key}',
  'ppl.dict.key': 'المفتاح',
  'ppl.dict.type': 'النوع',
  'ppl.dict.classification': 'الحماية',
  'ppl.dict.collect': 'يُطلب في',
  'ppl.dict.categories': 'الفئات',
  'ppl.dict.categoriesHint': 'رموز الفئات مفصولة بفواصل.',
  'ppl.dict.requiredFor': 'مطلوب للفئات',
  'ppl.dict.required': 'مطلوب',
  'ppl.dict.options': 'الخيارات',
  'ppl.dict.optionsHint': 'خيار في كل سطر: القيمة=التسمية الإنجليزية|التسمية العربية',
  'ppl.dict.purposes': 'أغراض الكشف',
  'ppl.dict.purposesSub': 'يجب أن يذكر كل كشف لقيمة مخفية أحد هذه الأغراض.',
  'ppl.dict.code': 'الرمز',
  'ppl.dict.addPurpose': 'إضافة غرض',
  'ppl.dict.revealSeconds': 'مدة عرض القيم المكشوفة (ثوانٍ)',
  'ppl.dict.saveDraft': 'حفظ المسودة',
  'ppl.dict.publish': 'نشر المسودة',
  'ppl.dict.discard': 'تجاهل المسودة',
};
